import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { IPPActivation } from 'src/app/models/IPersonalInfo';
import { title } from 'process';

export class ConfirmDialogModelPP {
  constructor(public title: string, public userdetails: string) {
  }
}

@Component({
  selector: 'app-print-patient-user-details',
  templateUrl: './print-patient-user-details.component.html',
  styleUrls: ['./print-patient-user-details.component.css']
})
export class PrintPatientUserDetailsComponent implements OnInit {
  title: string;
  userName: string;
  password: string;
  PPLink: string;
  // Fixed length so the mask does not reveal the password length.
  readonly maskedPassword = '**********';
  lstPopAlertsInfo: any;
  constructor(public dialogRef: MatDialogRef<PrintPatientUserDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModelPP) { }

  ngOnInit() {
    ;
    this.title = this.data.title
    this.lstPopAlertsInfo = this.data.userdetails;
    if (this.lstPopAlertsInfo != "" && this.lstPopAlertsInfo != null) {
      this.userName = this.lstPopAlertsInfo.userName;
      this.password = this.lstPopAlertsInfo.password;
      this.PPLink = this.lstPopAlertsInfo.actvivationLink;
    }
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onPrint(divName) {
    ;
    let printContents, popupWin;
    // Built from the values (not the on-screen markup) so the printout carries the real password.
    printContents = `
      <p><b>Activation Link: </b>${this.escapeHtml(this.PPLink)}</p><br>
      <p><b>User Name:</b> ${this.escapeHtml(this.userName)}</p><br>
      <p><b>Password:</b> ${this.escapeHtml(this.password)}</p>`;
    popupWin = window.open('', '', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Patient Portal Activation</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
}

  private escapeHtml(value: string): string {
    return (value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
}
